import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {MdDialog} from "@angular/material";
import {LoadingDialogComponent} from "../components/loading-dialog/loading-dialog.component";

@Injectable()
export class LoadingServiceProvider {
  spinner: any;

  constructor(
    public dialog: MdDialog
  ) {}

  showLoading() {
    this.dialog.open(LoadingDialogComponent, {
      height: '140px',
      width: '150px',
      disableClose: true
    });
  }

  hideLoading() {
      this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/loading-service.ts